import axios from '@/shared/utils/axios-init';
import sortFinanceData from '@/shared/utils/helpers/sortFinanceData';
import market from './modules/market';
import finance from './modules/finance';
import orders from './modules/orders';
import calculator from './modules/calculator';
import requests from './modules/requests';
import history from './modules/history';
import chat from './modules/chat';
import banner from './modules/banner';

/* eslint-disable */
const initialState = {
  timestamp: null,
};

const getters = {
  getTimestamp(state) {
    return state.timestamp;
  },
};

const mutations = {
  setTimestamp(state, timestamp) {
    state.timestamp = timestamp;
  },
};

const actions = {
  async updateDashboardData({ commit, rootState }, credentials) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/dashboard/update',
        JSON.stringify({
          couple: { 
            'base': credentials.couple.baseCurrency, 
            'quoted': credentials.couple.quoteCurrency 
          },
          timestamp: credentials.timestamp,
          market_quoted: credentials.selectedQuated
        }),
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const updatedDashboardData = data.data;

      // write data for Calculator Block
      if (updatedDashboardData.fee) {
        commit('orders/setFee', updatedDashboardData.fee);
      }

      // write data for Orders Block
      if (updatedDashboardData.orders) {
        commit('orders/setBuyOrdersData', updatedDashboardData.orders.buy_orders.list);
        commit('orders/setBuyMinPrice');
      }
      if (updatedDashboardData.orders) {
        commit('orders/setSellOrdersData', updatedDashboardData.orders.sell_orders.list);
        commit('orders/setSellMinPrice');
      }

      // write data for Market Block
      if (updatedDashboardData.market) {
        commit('market/setCurrencyData', updatedDashboardData.market);
      }

      // write data for Finance Block
      if (updatedDashboardData.finance) {
        commit('finance/setFinanceData', sortFinanceData(updatedDashboardData.finance));

        // set balance for currencies pair
        const baseCurrencyBalance = finance.state.financeData.find(cur => cur.curr_code === market.state.currenciesPair.baseCurrency);
        const quoteCurrencyBalance = finance.state.financeData.find(cur => cur.curr_code === market.state.currenciesPair.quoteCurrency);
        commit('finance/setBaseCurrencyBalance', +baseCurrencyBalance.amount);
        commit('finance/setQuoteCurrencyBalance', +quoteCurrencyBalance.amount);
      }

      // write data for Requests Block
      if (updatedDashboardData.my_orders) {
        commit('requests/setRequestsData', updatedDashboardData.my_orders);
      }

      // write data for History Block
      if (updatedDashboardData.deals) {
        commit('history/setHistoryData', updatedDashboardData.deals);
      }

      // write timestamp data
      if (updatedDashboardData.timestamp) {
        commit('setTimestamp', updatedDashboardData.timestamp);
      }

      // write market rates data
      if (updatedDashboardData.sell_rate) {
        commit('calculator/setSellRate', updatedDashboardData.sell_rate);
      }
      if (updatedDashboardData.market_buy_rate) {
        commit('calculator/setMarketBuyRate', updatedDashboardData.market_buy_rate);
      }
      if (updatedDashboardData.market_sell_rate) {
        commit('calculator/setMarketSellRate', updatedDashboardData.market_sell_rate);
      }
      if (updatedDashboardData.commission_market_buy) {
        commit('orders/setMarketBuyFee', updatedDashboardData.commission_market_buy);
      }
      if (updatedDashboardData.commission_market_price) {
        commit('orders/setMarketSellFee', updatedDashboardData.commission_market_price);
      }
      if (updatedDashboardData.dealstat) {
        commit('banner/setBannerState', updatedDashboardData.dealstat);
      }
      

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  modules: {
    market,
    finance,
    orders,
    calculator,
    requests,
    history,
    chat,
    banner,
  },
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/store.js